import { Amplify } from "aws-amplify";
import { MutationCache, QueryCache, QueryClient } from "react-query";
import store from "store";

const awsProd = {
  endpoint: process.env.REACT_APP_TWIIK_AWS_ENDPOINT_PROD,
  region: "eu-west-1",
  defaultAuthMode: "AWS_LAMBDA",
  apiKey: process.env.REACT_APP_TWIIK_AWS_KEY_PROD,
};

const awsDev = {
  endpoint: process.env.REACT_APP_TWIIK_AWS_ENDPOINT_DEV,
  region: "eu-west-1",
  defaultAuthMode: "AWS_LAMBDA",
  apiKey: process.env.REACT_APP_TWIIK_AWS_KEY_DEV,
};

Amplify.configure({
  API: {
    GraphQL:
      process.env.NODE_ENV === "production" &&
      process.env.REACT_APP_STAGE !== "dev"
        ? awsProd
        : awsDev,
  },
});

const errorFunction = async (error, query) => {
  const errors = error?.errors || [];
  const isUnauthorized = errors.some((err) => err.message === "Unauthorized");

  if (isUnauthorized) {
    queryClient.clear();

    store.dispatch({
      type: "LOGOUT",
    });
  }

  console.error("[NETWORK ERROR WITHOUT EXISTING CACHE]: ", error?.errors);

  if (query?.state?.data !== undefined) {
    // only show error if we already have data in the cache which indicates a failed background update
    console.error("[NETWORK ERROR WITH EXISTING CACHE]: ", error?.errors);
  }
};

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      notifyOnChangeProps: "tracked",
    },
  },
  mutationCache: new MutationCache({
    onError: errorFunction,
  }),
  queryCache: new QueryCache({
    onError: errorFunction,
  }),
});
